// PDF.js worker configuration
// This file ensures the worker is configured before any PDF components are used
import { pdfjs } from 'react-pdf';

// Set up PDF.js worker - use public directory path
// The worker file is automatically copied to public/ by the Vite plugin in vite.config.ts
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
